const base = '/settings'

export const settings = {
    roles: `/roles`,
}